import { render, staticRenderFns } from "./AdminOrganization.vue?vue&type=template&id=05e98dcc&scoped=true&"
import script from "./AdminOrganization.vue?vue&type=script&lang=js&"
export * from "./AdminOrganization.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrganization.vue?vue&type=style&index=0&id=05e98dcc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e98dcc",
  null
  
)

export default component.exports